import { IActionNavItem, IHrefNavItem, ILinkNavItem } from '@web_opxp/components';
import { ObFlowService } from '@web_opxp/features';
import { LanguageService } from '@web_opxp/language';
import { HistoryService } from 'web_core_library';
import { TrainingBaseUrl } from '../../base/env';
import { EBlogUrls, getBlogPage } from '../../base/utils';

const blogItem: IHrefNavItem = {
  kind: 'href',
  label: 'common.common:Header.Menu.Science',
  // link is empty while it will be rewritten in menu generation function
  link: '',
};

const getBlogItem = (language: string, blogUrl?: EBlogUrls): IHrefNavItem => ({
  ...blogItem,
  label: LanguageService.getTFunction()(blogItem.label),
  link: getBlogPage(language, blogUrl),
});

const getAccountItem = (accountTitle: string, accountAction?: () => void) => {
  const accountItem: IActionNavItem = {
    kind: 'action',
    action: '',
    label: accountTitle,
    onAction: accountAction,
  };
  return accountItem;
};

export const getNextObStepLink = (
  search: string,
  currentStepName?: string,
  language?: string,
  session?: string,
  className?: string,
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
) => {
  const nextObStep = ObFlowService.getNextObStep(currentStepName);
  if (nextObStep === null) {
    const dashboardUrl = HistoryService.getExternalUrl(TrainingBaseUrl, language, session);
    const dashboardLink: IHrefNavItem = {
      kind: 'href',
      label: LanguageService.getTFunction()('common.common:Header.Menu.Start'),
      link: dashboardUrl,
      className: className,
      onClick: onClick,
    };
    return dashboardLink;
  }
  const { app, path } = nextObStep;
  if (app !== 'onboarding') {
    const externalUrl = ObFlowService.getNextObUrl(nextObStep, language, session);
    const externalLink: IHrefNavItem = {
      kind: 'href',
      label: LanguageService.getTFunction()('common.common:Header.Menu.Start'),
      link: externalUrl,
      className: className,
      onClick: onClick,
    };
    return externalLink;
  }
  const internalUrl = HistoryService.getInternalUrl(path, search);
  const internalLink: ILinkNavItem = {
    kind: 'link',
    label: LanguageService.getTFunction()('common.common:Header.Menu.Start'),
    link: internalUrl,
    className: className,
    onClick: onClick,
  };
  return internalLink;
};

export const getMenu = (
  language: string,
  search: string,
  accountTitle: string,
  accountAction?: () => void,
  currentStepName?: string,
  session?: string,
  blogUrl?: EBlogUrls,
  className?: string,
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
) => {
  const obStepItem = getNextObStepLink(search, currentStepName, language, session, className, onClick);
  const blogItem = getBlogItem(language, blogUrl);
  const accountItem = getAccountItem(accountTitle, accountAction);
  return [obStepItem, blogItem, accountItem];
};

export default getMenu;
